module.exports = __webpack_public_path__ + "northern-cyprus.svg?934bed5071e40bac31ab7245290b35a4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/northern-cyprus.svg
// module id = 253
// module chunks = 10